import React, { Component } from "react";
import { View, Animated, Text, Easing, TouchableOpacity, StyleSheet } from "react-native";

import * as x from "../../styles/css";

class HomeButton extends Component {
	render() {
		return (
			<Animated.View
				style={[
					x.d.flex,
					{
						borderWidth: 1,
						borderColor: "rgba(255,255,255,0.2)",
					},
					this.props.color ? {backgroundColor: this.props.color} : {},
					this.props.connected ? {} : {opacity: 0.2},
					this.props.style,
				]}
			>
				<TouchableOpacity
					onPress={this.props.onPress}
					style={[
						x.d.flex,
						x.alignItems.center,
						x.justifyContent.center
					]}
				>
					{this.props.children}
				</TouchableOpacity>
			</Animated.View>
		);
	}
}

export default HomeButton;


// WEBPACK FOOTER //
// ./src/components/HomeButton/index.js